import React from "react";
import { useAppUpdate } from "../../hooks/useAppUpdate";

/** Slim bar offering the new build; the hook also reloads by itself when idle. */
const UpdateNotice: React.FC = () => {
  const { updateAvailable, newBuild, reload, dismiss } = useAppUpdate();
  if (!updateAvailable) return null;
  return (
    <div
      role="status"
      className="print:hidden fixed inset-x-0 top-16 z-[70] flex justify-center px-4"
    >
      <div className="flex items-center gap-3 rounded-full border border-paper-300/70 bg-surface px-4 py-2 text-sm text-ink shadow-card">
        <span>
          A new version of Telcofy is available
          {newBuild && <span className="ml-1 font-mono text-[11px] text-ink-faint">{newBuild}</span>}
        </span>
        <button
          onClick={reload}
          className="rounded-full bg-brand-500 px-3 py-1 text-xs font-semibold text-on-brand transition-colors hover:bg-brand-600"
        >
          Reload
        </button>
        <button onClick={dismiss} className="text-xs text-ink-muted hover:text-ink" aria-label="Not now">
          Later
        </button>
      </div>
    </div>
  );
};

export default UpdateNotice;
